import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowNews from '../components/News/ShowNews'

const News:React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("les actualités")}</h1>
      <ShowNews />
    </div>
  )
}

export default News
